import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useCurrentTheme } from "@/theming/useCurrentTheme";
import { ThemeType } from "@/theming/baseTheme";

interface SectionHeaderProps {
    title: string;
    actionText?: string;
    onActionPress?: () => void;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
                                                                title,
                                                                actionText,
                                                                onActionPress,
                                                            }) => {
    const { theme } = useCurrentTheme();
    const styles = createStyles(theme);

    return (
        <View style={styles.sectionHeader}>
            <Text style={styles.sectionTitle}>{title}</Text>
            {actionText && onActionPress && (
                <TouchableOpacity onPress={onActionPress}>
                    <Text style={styles.seeAllBtn}>{actionText}</Text>
                </TouchableOpacity>
            )}
        </View>
    );
};

const createStyles = (theme: ThemeType) => StyleSheet.create({
    sectionHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: theme.spacing.lg,
        marginBottom: theme.spacing.md,
    },

    sectionTitle: {
        fontSize: theme.fontSize.lg,
        fontWeight: '700',
        color: theme.colors.text,
    },

    seeAllBtn: {
        color: theme.colors.primary,
        fontSize: theme.fontSize.sm,
        fontWeight: '600',
    },
});
